<div class="contentRow">
    <ng-container *ngFor="let contentEntry of ContentRow.entries">
        <sbw-contentful-info-block [InfoBlock]="contentEntry" (onToggleExpand)="onToggleExpandInfoBlock($event)" [InfoBlockBehaviour]="InfoBlockBehaviour"></sbw-contentful-info-block>
    </ng-container>
</div>